var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalefaccionindividual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3392_14334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5C7.23743 13.9403 6.64145 14.6199 6.30448 15.4334C5.96752 16.2469 5.9084 17.1488 6.1363 17.9994C6.3642 18.8499 6.86638 19.6015 7.56496 20.1375C8.26353 20.6736 9.11946 20.9641 10 20.9641C10.8805 20.9641 11.7365 20.6736 12.435 20.1375C13.1336 19.6015 13.6358 18.8499 13.8637 17.9994C14.0916 17.1488 14.0325 16.2469 13.6955 15.4334C13.3586 14.6199 12.7626 13.9403 12 13.5V5C12 4.46957 11.7893 3.96086 11.4142 3.58579C11.0391 3.21071 10.5304 3 10 3C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21072 3.96086 8 4.46957 8 5V13.5Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9H12",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4.5C16 4.89782 16.158 5.27936 16.4393 5.56066C16.7206 5.84196 17.1022 6 17.5 6C17.8978 6 18.2794 5.84196 18.5607 5.56066C18.842 5.27936 19 4.89782 19 4.5C19 4.10218 18.842 3.72064 18.5607 3.43934C18.2794 3.15804 17.8978 3 17.5 3C17.1022 3 16.7206 3.15804 16.4393 3.43934C16.158 3.72064 16 4.10218 16 4.5Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11V10C14 9.46957 14.1844 8.96086 14.5126 8.58579C14.8408 8.21071 15.2859 8 15.75 8H19.25C19.7141 8 20.1592 8.21071 20.4874 8.58579C20.8156 8.96086 21 9.46957 21 10V11",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3392_14334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalefaccionindividual);
export default __webpack_public_path__ + "static/media/Calefaccion individual.6d98809aca5142a6bcf347c86c85a35e.svg";
export { ForwardRef as ReactComponent };